import callAPI from "commons/callAPI";
import config from "../commons/config";
import { setSessionStorage } from "./storageUtil";

export const fetchAgeRestrictionPromptData = async () => {
  try {
    let configData = {};
    const apiUrl = config.api.cms.alcoholAlert;
    const response = await callAPI.get(apiUrl);
    const regResponse = await response.json();

    if (regResponse?.data) {
      configData.ageRestrictionPromptData = regResponse?.data?.[0]?.attributes;
      setSessionStorage("configData", configData);
    }
    return response.data !== null;
  } catch (e) { }
};

export const fetchSoftLaunchPromptData = async () => {
  try {
    let configData = {};
    let apiURL = config.api.pages.replace("{{pageId}}", "soft-launch");
    let apiResponse = await callAPI.get(apiURL);
    let regResponse = await apiResponse.json();
    if (apiResponse.status === 200) {
      configData.softLaunchPromptData = regResponse || {};
      setSessionStorage("softLaunchData", configData);
      return configData || {};
    }
    return {};
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const fetchDarkSitePromptData = async () => {
  try {
    let configData = {};
    let apiURL = config.api.pages.replace("{{pageId}}", "dark-site");
    let apiResponse = await callAPI.get(apiURL);
    let regResponse = await apiResponse.json();
    if (apiResponse.status === 200) {
      configData.darkSitePromptData = regResponse || {};
      setSessionStorage("darkSiteData", configData);
      return configData || {};
    }
    return {};
  } catch (e) {
    console.log(e);
    return {};
  }
};
